import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

export default class AppNotificationsPromotionsGrowth2024TrialComponent extends Component {
	@service('flow/promotions')
	declare flowPromotionsService: Service.Flow.Promotions;

	get promotion() {
		return this.flowPromotionsService.promotions.growthFeatureTrialActivePromotion;
	}
	<template>
		<div class="notification-container promotions-growth-2024-trial-notification">
			<div class="container">
				<p>
					<span>
						<b></b>
						We’ve unlocked 14-day free trial of Growth plan features for you and your
						team.
					</span>
					<div class="actions">
						<a class="button theme-blue-outlined size-small">
							{{this.promotion.timeLeftText}}
							left
						</a>
					</div>
				</p>
			</div>
		</div>
	</template>
}
